import { motion } from "framer-motion";
import { Lightbulb, Target, Rocket } from "lucide-react";

const AboutSection = () => {
  return (
    <section
      id="about"
      className="py-24 md:py-32 relative"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://img.pikbest.com/ai/illus_our/20230428/321d4f719a00e6b20b6ccec2c5f93594.jpg%21w700wp"
                alt="GuruTech AI Team Collaboration"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-void via-transparent to-transparent" />
            </div>

            {/* Floating Stats Card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="absolute -bottom-8 -right-8 glass-card p-6 max-w-xs"
            >
              <p className="font-unbounded font-bold text-3xl text-white mb-1">
                2025
              </p>
              <p className="text-sm text-muted-foreground">
                Building the future of AI, one solution at a time
              </p>
            </motion.div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <p className="font-jetbrains text-xs tracking-widest uppercase text-neon-cyan mb-4">
              About GuruTech AI
            </p>
            <h2 className="section-title mb-6">
              Making AI
              <br />
              <span className="text-gradient">Accessible & Impactful</span>
            </h2>
            <div className="space-y-6 text-muted-foreground leading-relaxed">
              <p>
                GuruTech AI was founded with a singular vision: to democratize
                access to cutting-edge AI technology for businesses of all sizes.
                We believe that AI shouldn't be reserved for tech giants—every
                business deserves intelligent solutions that drive growth.
              </p>
              <p>
                Our team combines deep expertise in machine learning, natural
                language processing, and computer vision with a profound
                understanding of business challenges. We don't just build AI—we
                build solutions that solve real problems.
              </p>
            </div>

            {/* Vision Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
              <div className="glass-card p-4 text-center">
                <Lightbulb className="w-6 h-6 text-electric-violet mx-auto mb-2" />
                <p className="text-sm font-medium text-white">Innovation</p>
              </div>
              <div className="glass-card p-4 text-center">
                <Target className="w-6 h-6 text-neon-cyan mx-auto mb-2" />
                <p className="text-sm font-medium text-white">Precision</p>
              </div>
              <div className="glass-card p-4 text-center">
                <Rocket className="w-6 h-6 text-white/60 mx-auto mb-2" />
                <p className="text-sm font-medium text-white">Growth</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
